import type { Option } from 'hb-builder/utils/dynamicSelectorsHelpers';
import type { SectionItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/sectionItemAttributes';

export interface QueryAttributes {
  categories?: Option[];
  dataDiscussionsType:
    | 'last_published'
    | 'pinned'
    | 'most_popular'
    | 'followed_by_user';
  dataPostsType: 'last_created' | 'top_post';
  dataTopicType: 'last_created';
  dataType: 'upcoming' | 'last_published';
  dataUserType: 'recently_joined' | 'close';
  numberOfItems: number;
}

interface HeadlinesAttributes {
  discussions: string;
  events: string;
  news: string;
  posts: string;
  topics: string;
}

export interface SublinesAttributes {
  display: boolean;
  type: string;
}

export enum SLIDER_TYPES {
  DISCUSSIONS = 'discussions',
  EMPTY = 'empty',
  EVENTS = 'events',
  NEWS = 'news',
  POSTS = 'posts',
  TOPICS = 'topics',
  USERS = 'users',
}

export interface SliderDynamicAttributes {
  firstSubline: SublinesAttributes;
  headlines: HeadlinesAttributes;
  query: QueryAttributes;
  secondSubline: SublinesAttributes;
  singleLine: boolean;
  title: string;
  type: SLIDER_TYPES;
}

export interface SliderItemAttributes extends SectionItemAttributes {
  dynamicAttributes: SliderDynamicAttributes;
}
